import React from "react";
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import PickUpIcon from "./icons/LocationMarker.svg";
import DropOffIcon from "./icons/DO_icon_map.svg";
import Car from "./Car";
import CarSearchingAnimation from "./CarSearchingAnimation";
import { lightThemeMapCTG, darkThemeMap } from "./mapStyles";
import AnimatingPolylineComponent from "./AnimatingPolylineComponent";

const containerStyle = {
  width: '100%',
  height: '100%'
};

const GoogleMapBlock = React.memo((props) => {

  const [map, setMap] = React.useState(null);

  React.useEffect(() => {
    const google = window.google;
    const bounds = new google.maps.LatLngBounds();
    const start = props.puPoint;
    const stop = props.doPoint;

    if (start) {
      bounds.extend(new google.maps.LatLng(start.lat, start.lng));
    }
    if (stop) {
      bounds.extend(new google.maps.LatLng(stop.lat, stop.lng));
    }
    if (props.routePathPolyline?.length) {
      props.routePathPolyline.forEach(({ lat, lng }) => {
        bounds.extend(new google.maps.LatLng(lat, lng));
      });
    }
    if (map && (start || stop)) {
      map.fitBounds(bounds, {
        bottom: 20,
        left: 500,
        right: 20,
        top: 20,
      });
      setMap(map);
    }
  }, [ props.puPoint, props.doPoint, props.routePathPolyline ]);

  const onLoad = React.useCallback(function callback(map) {
    const center = new window.google.maps.LatLng(props.mapCenter.lat, props.mapCenter.lng);
    map.setCenter(center);
    map.setZoom(11);
    setMap(map)
  }, []);

  const renderPickUp = () => props.puPoint &&
    <Marker
      icon={{
        url: PickUpIcon,
        scaledSize: {
          width: 35,
          height: 35,
        },
      }}
      position={props.puPoint}
      zIndex={200}
    />;

  const renderDropOff = () => props.doPoint &&
    <Marker
      icon={{
        url: DropOffIcon,
        scaledSize: {
          width: 28,
          height: 28,
        },
      }}
      position={props.doPoint}
      zIndex={200}
    />;

  const renderRoute = () => props.routePathPolyline &&
    <Polyline
      path={props.routePathPolyline}
      options={{
        strokeColor: "#344995",
        strokeWeight: 3,
      }}
    />;

  const renderRouteAnimate = () => props.routePathPolyline &&
    <AnimatingPolylineComponent
      direction={[ ...props.routePathPolyline ].reverse()}
    />;

  const renderClosestCar = () => props.carsArray?.map?.((car) => car.id &&
    <Car
      key={car.id}
      lat={car.lat}
      lng={car.lng}
    />,
  );

  const renderCarSearching = () => props.searchingMode &&
    <CarSearchingAnimation
      key={props?.puPoint?.lat + props?.puPoint?.lng}
      lat={props?.puPoint?.lat}
      lng={props?.puPoint?.lng}
    />;

  return(
    <GoogleMap
      ref={map}
      id={props.mapCenter.lat + props.mapCenter.lng}
      mapContainerStyle={containerStyle}
      center={props.mapCenter}
      zoom={11}
      onLoad={onLoad}
      options={{
        mapTypeControl: false,
        zoomControl: true,
        streetViewControl: false,
        fullscreenControl: false,
        draggable: true,
        disableDoubleClickZoom: true,
        maxZoom: 17,
        styles: props.themeLightStyle ? darkThemeMap : lightThemeMapCTG,
      }}
    >
      {renderPickUp()}
      {renderDropOff()}
      {renderRoute()}
      {renderRouteAnimate()}
      {renderClosestCar()}
      {renderCarSearching()}
    </GoogleMap>);
});

export default GoogleMapBlock;

